import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import i18n from './i18n'
import store from '@/store/store'
import '@/assets/css/custom.css'
import VueMeta from 'vue-meta'
import VueMixpanel from 'vue-mixpanel'

import dateUtil from '@/js/utils/dateUtil'

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

//Tracking tools
import VueGtag from "vue-gtag";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import slack from './js/services/slack'

Vue.config.productionTip = false

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})


Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GTAG },
  appName: 'ASport',
  enabled: process.env.VUE_APP_GTAG,
  pageTrackerScreenviewEnabled: true,
  // gtag.js loads only after the visitor accepts cookies (src/domains/consent, [B33]).
  bootstrap: false
}, router);
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  /*
   * Which environment an event came from. Without this the SDK labels everything "production",
   * so a dev or stage error is indistinguishable from a real customer one.
   * Deliberately not NODE_ENV: that is "production" for every `vue-cli-service build`, including
   * the dev and stage builds, so it would keep lying. A build that forgets the variable is
   * visibly "unknown" instead.
   */
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'unknown',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "asport.lv", /^\//],
    }),
  ],
  tracesSampleRate: 1.0,
});

Vue.use(VueMixpanel, {
  token: process.env.VUE_APP_MIXPANEL_TOKEN ? process.env.VUE_APP_MIXPANEL_TOKEN : null,
  config: {
    track_pageview: "full-url",
    api_host: "https://api-eu.mixpanel.com",
    // No tracking until the visitor accepts cookies (src/domains/consent, [B33]).
    opt_out_tracking_by_default: true,
    // Without this Mixpanel still writes its cookie (with a distinct_id) before consent;
    // opt_in_tracking() turns storage back on after "Piekrītu".
    opt_out_persistence_by_default: true,
    //debug: true
  }
})

Vue.use(Toast)


Vue.filter('formatDate', function (value) {
  if (value) {
    return dateUtil.formatDate(value)
  }
})
Vue.filter('formatDateTime', function (value) {
  if (value) {
    return dateUtil.formatDateTime(value)
  }
})
Vue.filter('formatShortDateTime', function (value) {
  if (value) {
    return dateUtil.formatShortDateTime(value)
  }
})

Vue.config.errorHandler = (err) => {
  console.error('Got error!', err);
  slack.sendMessage('Website errorHandler on page: ' + (window  && window.location ? window.location.href : 'unknown..') + ' with error: ' + err);
  throw err
};
/*
 * In-app browsers (Facebook, Instagram) inject their own scripts into every page, and those
 * scripts throw on iOS. Such an error has no frame from any script file — its whole stack is
 * "global code@<page URL>" — so it is not ours and the user does not notice it. Reporting it
 * to Slack is only noise.
 */
const IN_APP_BROWSER_USER_AGENT = /FBAN|FBAV|Instagram/;
const SCRIPT_FILE_FRAME = /\.js:\d+/;

function isInjectedByInAppBrowser(error) {
  return IN_APP_BROWSER_USER_AGENT.test(window.navigator.userAgent)
    && !!error.stack
    && !SCRIPT_FILE_FRAME.test(error.stack);
}

window.onerror = function(message, source, lineno, colno, error) {
  console.error('Website error - window!', message, source, lineno, colno, error);
  if (!error){
    return false;
  }
  if (isInjectedByInAppBrowser(error)) {
    console.warn('Ignored error from a script the in-app browser injected', message, error.stack);
    return false;
  }

  let details = "";
  if (message) {
    details += "Message: " + message + "; "
  }
  if (source) {
    details += "Source: " + source + "; "
  }
  if (lineno) {
    details += "LineNo: " + lineno + "; "
  }
  if (colno) {
    details += "ColNo: " + colno + "; "
  }
  if (error) {
    details += "Error: ["
    if (error.message) {
      details += "msg: " + error.message + "; "
    }
    if (error.stack) {
      details += "stack: " + error.stack + "; "
    }
    details += "]; "
  }

  //get device info
  details += "Device: ["
  if (window && window.navigator) {
    details += "UserAgent: " + window.navigator.userAgent + "; "
  }
  if (window && window.screen) {
    details += "Screen: " + window.screen.width + "x" + window.screen.height + "; "
  }
  details += "]; "

  slack.sendMessage('Website onError at page: ' + (window  && window.location ? window.location.href : 'unknown..') + ' with details: ' + details);
};
/*window.addEventListener('unhandledrejection', function(event) {
  console.log('Got error - event!', event, event.promise, event.reason)
  slack.sendMessage('Got error: ' + event.promise + " => " + event.reason);
  return
});*/

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
